const Url = {
  // baseURL: ["http://localhost:7185/"],
  // baseURL: ["http://192.168.45.176:7185/"],
  // baseURL: ["https://dentalcaries.ir/"],
  baseURL: ["https://app.dentware.net/"],
  action: "action",
  /////////Login
  login: "api/Auth/login",

  ///////student
  getListPatient: "api/Student/GetListPatient",
  savePatintImageDetail: "api/Student/SaveImageDetail",
  GetImageDetailById: "api/Student/GetImageDetailById",
  RegisterStudent: "api/Student/register",
  isExamAccepted: "api/Student/isStudentPassExam",
  deleteImageDetail: "api/Student/DeleteImageDetailById",
  saveSeeDemo: "api/Student/saveSeeDemo",

  ////fileeee
  downloadImage: "api/File/Image_download?fileName=",

  /////professor
  getStudentList: "api/Professor/GetListStudent",
  GetPatientNotAssigned: "api/Professor/GetPatientNotAssigned",
  SetPatientToStudent: "api/Professor/SetPatientToStudent",
  GetLabeling: "api/Professor/GetLabeling",
  SaveRanked: "api/Professor/SaveRanked",
  Professor_getatientOfStudent: "api/Professor/getatientOfStudent",
  registerLateralCephaloUser: "api/Professor/registerLateralCephaloUser",
  registerNumberingTeethUser: "api/Professor/registerNumberingTeethUser",
  registerSegmentCariesUser: "api/Professor/registerSegmentCariesUser",
  ListSegmentCariesUser: "api/Professor/ListSegmentCariesUser",
  ListNumberingTeethUser: "api/Professor/ListNumberingTeethUser",
  registerImplantUser: "api/Professor/registerImplantUser",
  ListImplantUser: "api/Professor/ListImplantUser",
  registerProfileAnalysistUser: "api/Professor/registerProfileAnalysisUser",
  ListProfileAnalysisUser: "api/Professor/ListProfileAnalysisUser",
  registerOpgNumberingUser: "api/Professor/registerOpgNumberingUser",
  ListOpgNumberingUser: "api/Professor/ListOpgnumberingUser",
  registerPeriapicallesionUser: "api/Professor/registerPeriapicallesionUser",
  ListPericallesionUser: "api/Professor/ListPericallesionUser",
  registercbctaiUser: "api/Professor/registerCbctAiUser",
  ListcbctaiUser: "api/Professor/ListcbctaiUser",

  ////Exam
  GetListExam: "api/Exam/GetListExam",
  saveStudentDignous: "api/Exam/SaveImageDetailForExam",
  getImagDetailForExam: "api/Exam/GetImageDetail",
  DeleteImageDetailExam: "api/Exam/DeleteImageDetail",
  GetImageDetailForStudent: "api/Exam/GetImageDetailForStudent",
  saveReportExamForStudent: "api/Exam/SaveReportExamForStudent",
  GetImageDetailOfStudent: "api/Exam/GetImageDetailOfStudent",

  ////file
  file_upload_dental: "api/File/Dental_uploadFile",
  dental_file_donwload: "api/File/Dental_download?fileName=",
  implantImage: "api/File/ImplantImage?fileName=",

  ////lateral Cephalo
  getPatienListForLateralCephalo:
    "api/LateralCephalo/GetPatientForLateralCephalo",
  getPatientLateralPhoto: "api/LateralCephalo/GetLateralPhoto",
  saveLateralAnalyses: "api/LateralCephalo/SaveAnalyses",
  lateral_GetListAnalyses: "api/LateralCephalo/GetListAnalyses",
  lateral_GetPhotoForEdit: "api/LateralCephalo/GetLateralPhotoForEdit",
  getuserIfChephalo: "api/LateralCephalo/GetInfoUser",
  GetPatientForLateralCephaloExam:
    "api/LateralCephalo/GetPatientForLateralCephaloExam",
  saveLateralAnalysesExam: "api/LateralCephalo/SaveAnalysesExam",
  GetLateralPhotoExam: "api/LateralCephalo/GetLateralPhotoExam",
  GetPointWithAi: "api/LateralCephalo/GetPointWithAi?fileName=",
  GetPointWithAiWithId: "api/LateralCephalo/GetPointWithAiWithId",

  ////numberingTeeth
  getuserIfNumberTeeth: "api/NumberTeeth/GetInfoUser",
  GetListImageForNumberingTeeth:
    "api/NumberTeeth/GetListImageForNumberingTeeth",
  GetPhotoForTeeth: "api/NumberTeeth/GetPhotoForTeeth",
  saveAnalysesNumberTeeth: "api/NumberTeeth/saveAnalyses",
  numberTeethlistAnalyses: "api/NumberTeeth/listAnalyses",
  GetPhotoForTeethNumberingEdit:
    "api/NumberTeeth/GetPhotoForTeethNumberingEdit",
  GetOpgPhotonumbering: "api/NumberTeeth/GetOpgPhoto",
  PredictTeeth: "api/NumberTeeth/PredictTeeth?requestImageId=",
  photographyseeSegment:
    "api/NumberTeeth/PredictWithAiSegment?requestImageName=",

  ////segmentcaries
  getuserIfSegmentCaries: "api/SegmentCaries/GetInfoUser",
  GetListImageForSegmentation: "api/SegmentCaries/GetListImageForSegmentation",
  GetImageNotIntact: "api/SegmentCaries/GetImageNotIntact",
  SaveSegment: "api/SegmentCaries/SaveSegment",
  GetSegment: "api/SegmentCaries/GetSegment",
  segment_listAnalyses: "api/SegmentCaries/listAnalyses",

  ////implant
  getListImplant: "api/implant/getlistimage",
  implantsaveanswer: "api/implant/saveanswer",

  ////opg analyses
  getPatientForOpg: "api/opg/GetPatientForOpg",
  GetOpgPhoto: "api/opg/GetOpgPhoto",
  saveOpgAnalyses: "api/Opg/SaveAnalyses",
  saveAge: "api/Opg/SaveAge",
  saveSex: "api/Opg/SaveSex",

  /////OPG Numbering
  getuserInfoOPGNumbering: "api/OpgNumbering/GetInfoUser",
  GetListImageForOPGNumbering: "api/OpgNumbering/GetListImageForOpgNumbering",
  GetPhotoForNumberOpg: "api/OpgNumbering/GetPhotoForNumberOpg",
  GetPhotoForOpgnumberingEdit: "api/OpgNumbering/GetPhotoForOpgNumberingEdit",
  SaveAnalysisOpgNumbering: "api/OpgNumbering/saveAnalyses",
  opgnumberinglistAnalyses: "api/OpgNumbering/listAnalyses",
  opgPredictTeeth: "api/OpgNumbering/Predictopgnumbering?requestImageId=",
  opgSegmentationGetList: "api/OpgNumbering/GetListImageForOpgSegmentation",
  opgsegmentGetPhoto: "api/OpgNumbering/GetPhotoSegmentation",
  opgSaveSegment: "api/OpgNumbering/saveSegmentAnalyses",
  opgPredictSegment: "api/OpgNumbering/PredictWithAiSegment?requestImageName=",

  ///PeriapicalLesionController
  getuserInfoperispicallesion: "api/PeriapicalLesion/GetInfoUser",
  GetListImageForPeripicalLesion:
    "api/PeriapicalLesion/GetListImageForPeripicalLesion",
  GetPhotoForPeriapicalLesion:
    "api/PeriapicalLesion/GetPhotoForPeriapicalLesion",
  saveAnalysisForPeriapicalLesion:
    "api/PeriapicalLesion/saveAnalysisForPeriapicalLesion",
  GetPhotoForPeriapicalLesionEdit:
    "api/PeriapicalLesion/GetPhotoForPeriapicalLesionEdit",

  ///cbctaicontroller
  getuserInfocbctai: "api/CbctAi/GetInfoUser",
  cbctaiuploadimages: "api/CbctAi/uploadimages",
  GetListImageForCbctAi: "api/CbctAi/GetListImageForcbctai",
  GetPhotoForCbctAi: "api/CbctAi/GetPhotoForCbctAi",
  saveAnalysisForCbctAi: "api/CbctAi/saveAnalysisForCbctAi",
  GetPhotoForCbctAiEdit: "api/CbctAi/GetPhotoForCbctAiEdit",
  SaveCbctSegment: "api/CbctAi/SaveCbctSegment",
  GetCbctSegment: "api/CbctAi/GetCbctSegment",
  SaveCbctRuler: "api/CbctAi/SaveCbctRuler",
  GetCbctRuler: "api/CbctAi/GetCbctRuler",

  ////Profile Analysis
  getuserIfProfileAnalysis: "api/ProfileAnalysis/GetInfoUser",
  profile_GetPatientForProfileAnalysis:
    "api/ProfileAnalysis/GetPatientForProfileAnalysis",
  profile_FrontalSaveAnalyses: "api/ProfileAnalysis/FrontalSaveAnalyses",
  profile_FrontalGetAnalysesForEdit:
    "api/ProfileAnalysis/FrontalGetAnalysesForEdit",
  profile_FrontalGetPointWithAi: "api/ProfileAnalysis/FrontalGetPointWithAi",
  profile_ImportFrontalImages: "api/ProfileAnalysis/ImportFrontalImages",
  profile_ImportFrontalAnalysesFromJson:
    "api/ProfileAnalysis/ImportFrontalAnalysesFromJson",
  ////Public (بدون لاگین)
  publicCbctImplantLine: "api/PublicCbct/ImplantLine",
};

export default Url;
